module.exports = __webpack_public_path__ + "static/media/snappy.25379dcc.svg";